var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "blocks" },
    [
      _c(
        "div",
        {
          staticClass:
            "l-m-b-20 align-items-center d-flex justify-content-between"
        },
        [
          _c("div", { staticClass: "d-flex align-items-center title-search" }, [
            _c("h1", { staticClass: "pr-3" }, [_vm._v("Dashboard")]),
            _vm._v(" "),
            _vm.$_can("subco.dashboard.view") && _vm.dashboardType === "subco"
              ? _c("div", { staticClass: "input-group search" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn input-group-btn",
                      attrs: { type: "button" },
                      on: { click: _vm.clearSearch }
                    },
                    [
                      _c("i", {
                        class: [_vm.q ? "fa fa-remove" : "fa fa-search"]
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.q,
                        expression: "q"
                      }
                    ],
                    staticClass: "form-control search-input",
                    attrs: { type: "text", placeholder: "Search" },
                    domProps: { value: _vm.q },
                    on: {
                      keyup: function($event) {
                        _vm.searchText($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.q = $event.target.value
                      }
                    }
                  })
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-right pr-0 d-flex" },
            [
              _vm.$_can("subco.dashboard.view") &&
              _vm.$_can("sales.dashboard.view")
                ? _c(
                    "div",
                    { staticClass: "change-dashboard-wrap" },
                    [
                      _c("simple-select", {
                        attrs: {
                          options: _vm.dashboardTypes,
                          label: "name",
                          placeholder: "Change Dashboard"
                        },
                        model: {
                          value: _vm.dashboardType,
                          callback: function($$v) {
                            _vm.dashboardType = $$v
                          },
                          expression: "dashboardType"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass:
                          "mod-icon-chevron-down mr-3 position-absolute"
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "btn btn-primary btn-schedule",
                  attrs: { tag: "button", to: "/schedule" }
                },
                [_vm._v("\n        SCHEDULE\n      ")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.$_can("sales.dashboard.view") && _vm.dashboardType === "sales"
        ? [_c("SalesDashboard")]
        : _vm.$_can("subco.dashboard.view") && _vm.dashboardType === "subco"
          ? [
              _c("div", { staticClass: "row mb-3" }, [
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "mb-4 nav nav-tabs nav-fill" }, [
                    _c(
                      "div",
                      {
                        staticClass: "nav-item nav-link pointer",
                        class: [
                          _vm.step === "todayAndTomorrow" ? "active" : ""
                        ],
                        on: {
                          click: function($event) {
                            _vm.setStep("todayAndTomorrow")
                          }
                        }
                      },
                      [_vm._v("\n            Today and tomorrow\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "nav-item nav-link pointer",
                        class: [_vm.step === "upcoming" ? "active" : ""],
                        on: {
                          click: function($event) {
                            _vm.setStep("upcoming")
                          }
                        }
                      },
                      [_vm._v("\n            Upcoming\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "nav-item nav-link pointer",
                        class: [_vm.step === "completed" ? "active" : ""],
                        on: {
                          click: function($event) {
                            _vm.setStep("completed")
                          }
                        }
                      },
                      [_vm._v("\n            Completed jobs\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "nav-item nav-link pointer",
                        class: [_vm.step === "incomplete" ? "active" : ""],
                        on: {
                          click: function($event) {
                            _vm.setStep("incomplete")
                          }
                        }
                      },
                      [_vm._v("\n            Incomplete jobs\n          ")]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "l-m-b-20 align-items-center d-flex justify-content-between"
                },
                [
                  _vm.$_can("subco.dashboard.view")
                    ? _c("div", { staticClass: "col-12 filters-field" }, [
                        _c("span", [_vm._v("Filters:")]),
                        _vm._v(" "),
                        _vm.filtersLoaded
                          ? _c("span", [
                              _vm.filters.carrier.length && _vm.carriers
                                ? _c(
                                    "span",
                                    _vm._l(_vm.filters.carrier, function(
                                      carrier
                                    ) {
                                      return _c(
                                        "span",
                                        {
                                          key: carrier,
                                          staticClass:
                                            "filter-item btn btn-filter"
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "mod-icon-filter",
                                            on: {
                                              click: function($event) {
                                                _vm.removeFilter(
                                                  "carrier",
                                                  carrier
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(
                                            "\n              Carrier: " +
                                              _vm._s(
                                                _vm.carriers.find(function(el) {
                                                  return el.id === carrier
                                                }).name
                                              )
                                          )
                                        ]
                                      )
                                    })
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.filters.company.length && _vm.companies
                                ? _c(
                                    "span",
                                    _vm._l(_vm.filters.company, function(
                                      company
                                    ) {
                                      return _c(
                                        "span",
                                        {
                                          key: company,
                                          staticClass:
                                            "filter-item btn btn-filter"
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "mod-icon-filter",
                                            on: {
                                              click: function($event) {
                                                _vm.removeFilter(
                                                  "company",
                                                  company
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(
                                            "\n              Company: " +
                                              _vm._s(
                                                _vm.companies.find(function(
                                                  el
                                                ) {
                                                  return el.id === company
                                                }).name
                                              )
                                          )
                                        ]
                                      )
                                    })
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.filters.userCompanies &&
                              _vm.clusterUsersFilter.length
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "filter-item btn btn-filter"
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "mod-icon-filter",
                                        on: {
                                          click: function($event) {
                                            _vm.removeFilter("userCompanies")
                                          }
                                        }
                                      }),
                                      _vm._v(
                                        "\n            User companies: " +
                                          _vm._s(
                                            _vm.clusterUsersFilter.find(
                                              function(el) {
                                                return (
                                                  el.id ===
                                                  _vm.filters.userCompanies
                                                )
                                              }
                                            ).full_name
                                          )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.filters.moveSize
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "filter-item btn btn-filter"
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "mod-icon-filter",
                                        on: {
                                          click: function($event) {
                                            _vm.removeFilter("moveSize")
                                          }
                                        }
                                      }),
                                      _vm._v(
                                        "\n            Move Size: " +
                                          _vm._s(
                                            _vm.moveSizes.find(function(el) {
                                              return (
                                                el.id === _vm.filters.moveSize
                                              )
                                            }).name
                                          )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.filters.moveDate
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "filter-item btn btn-filter"
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "mod-icon-filter",
                                        on: {
                                          click: function($event) {
                                            _vm.removeFilter("moveDate")
                                          }
                                        }
                                      }),
                                      _vm._v(
                                        "\n            Move Date: " +
                                          _vm._s(_vm.filters.moveDate)
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.filters.status
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "filter-item btn btn-filter"
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "mod-icon-filter",
                                        on: {
                                          click: function($event) {
                                            _vm.removeFilter("status")
                                          }
                                        }
                                      }),
                                      _vm._v(
                                        "\n            Status: " +
                                          _vm._s(
                                            _vm.jobStatuses.find(function(el) {
                                              return (
                                                el.id === _vm.filters.status
                                              )
                                            }).name
                                          )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.filters.cash_collected
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "filter-item btn btn-filter"
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "mod-icon-filter",
                                        on: {
                                          click: function($event) {
                                            _vm.removeFilter("cash_collected")
                                          }
                                        }
                                      }),
                                      _vm._v(
                                        "\n            Cash collected: " +
                                          _vm._s(
                                            _vm.filters.cash_collected ===
                                            "true"
                                              ? "Yes"
                                              : "No"
                                          )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary add-filters",
                            on: {
                              click: function($event) {
                                _vm.showFilters = true
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-plus filter-icon" })]
                        )
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "section",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.step === "todayAndTomorrow",
                      expression: "step === 'todayAndTomorrow'"
                    }
                  ]
                },
                [
                  _c("div", { staticClass: "row mb-4" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("label", [_vm._v("TODAY")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "pull-right" }, [
                        _c(
                          "span",
                          { staticClass: "btn-status bg-grey border-right" },
                          [_vm._v(_vm._s(_vm.metaToday && _vm.metaToday.total))]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "btn-status bg-grey" }, [
                          _vm._v(
                            _vm._s(_vm.metaToday && _vm.metaToday.unassigned) +
                              " not assigned"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary expand-all",
                            attrs: {
                              disabled: _vm.jobsToday && !_vm.jobsToday.length
                            },
                            on: { click: _vm.toggleAllTodayJobs }
                          },
                          [
                            _c("i", {
                              class: [
                                _vm.jobsToday && _vm.expandedAllToday
                                  ? "fa fa-compress"
                                  : "fa fa-expand"
                              ]
                            })
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  !_vm.jobsToday
                    ? [
                        _c(
                          "vue-content-loading",
                          { attrs: { width: 800, height: 180 } },
                          _vm._l(5, function(x) {
                            return _c("rect", {
                              key: x,
                              attrs: {
                                x: "10",
                                y: 15 * x * 1.8,
                                rx: "5",
                                ry: "5",
                                width: "720",
                                height: "6"
                              }
                            })
                          })
                        )
                      ]
                    : [
                        _vm.jobsToday && _vm.jobsToday.length
                          ? _c(
                              "div",
                              _vm._l(_vm.jobsToday, function(job, index) {
                                return _c("JobsBlock", {
                                  key: index,
                                  attrs: {
                                    job: job,
                                    index: index,
                                    expanded: _vm.expandedToday,
                                    dashboard: true
                                  },
                                  on: {
                                    "update:job": function($event) {
                                      job = $event
                                    },
                                    "update:index": function($event) {
                                      index = $event
                                    },
                                    "job-updated": function($event) {
                                      _vm.updateJob(
                                        _vm.jobsToday,
                                        index,
                                        $event
                                      )
                                    },
                                    expanded: _vm.toggleJobToday,
                                    update: _vm.callGetJobsToday,
                                    showModalAcceptJob: function($event) {
                                      _vm.showModalAcceptJob = true
                                    }
                                  }
                                })
                              })
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.jobsToday && !_vm.jobsToday.length
                          ? _c("div", [
                              _vm._v("\n          No results found\n        ")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("pagination", {
                          attrs: {
                            "change-page": _vm.changePage,
                            meta: _vm.metaToday,
                            day: "today"
                          }
                        })
                      ],
                  _vm._v(" "),
                  _c("div", { staticClass: "row mt-5 mb-4" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("label", [_vm._v("TOMORROW")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "pull-right" }, [
                        _c(
                          "span",
                          { staticClass: "btn-status bg-grey border-right" },
                          [
                            _vm._v(
                              _vm._s(_vm.metaTomorrow && _vm.metaTomorrow.total)
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "btn-status bg-grey" }, [
                          _vm._v(
                            _vm._s(
                              _vm.metaTomorrow && _vm.metaTomorrow.unassigned
                            ) + " not assigned"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary expand-all",
                            attrs: {
                              disabled:
                                _vm.jobsTomorrow && !_vm.jobsTomorrow.length
                            },
                            on: { click: _vm.toggleAllTomorrowJobs }
                          },
                          [
                            _c("i", {
                              class: [
                                _vm.jobsTomorrow && _vm.expandedAllTomorrow
                                  ? "fa fa-compress"
                                  : "fa fa-expand"
                              ]
                            })
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  !_vm.jobsTomorrow
                    ? [
                        _c(
                          "vue-content-loading",
                          { attrs: { width: 800, height: 180 } },
                          _vm._l(5, function(x) {
                            return _c("rect", {
                              key: x,
                              attrs: {
                                x: "10",
                                y: 15 * x * 1.8,
                                rx: "5",
                                ry: "5",
                                width: "720",
                                height: "6"
                              }
                            })
                          })
                        )
                      ]
                    : [
                        _vm.jobsTomorrow && _vm.jobsTomorrow.length
                          ? _c(
                              "div",
                              _vm._l(_vm.jobsTomorrow, function(job, index) {
                                return _c("JobsBlock", {
                                  key: index,
                                  attrs: {
                                    job: job,
                                    index: index,
                                    expanded: _vm.expandedTomorrow,
                                    dashboard: true
                                  },
                                  on: {
                                    "update:job": function($event) {
                                      job = $event
                                    },
                                    "update:index": function($event) {
                                      index = $event
                                    },
                                    "job-updated": function($event) {
                                      _vm.updateJob(
                                        _vm.jobsTomorrow,
                                        index,
                                        $event
                                      )
                                    },
                                    expanded: _vm.toggleJobTomorrow,
                                    update: _vm.callGetJobsTomorrow,
                                    showModalAcceptJob: function($event) {
                                      _vm.showModalAcceptJob = true
                                    }
                                  }
                                })
                              })
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.jobsTomorrow && !_vm.jobsTomorrow.length
                          ? _c("div", [
                              _vm._v("\n          No results found.\n        ")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("pagination", {
                          attrs: {
                            "change-page": _vm.changePage,
                            meta: _vm.metaTomorrow,
                            day: "tomorrow"
                          }
                        })
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "section",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.step === "upcoming",
                      expression: "step === 'upcoming'"
                    }
                  ]
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 l-m-b-20" }, [
                      _c("label", [_vm._v("UPCOMING")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "pull-right" }, [
                        _c(
                          "span",
                          { staticClass: "btn-status bg-grey border-right" },
                          [
                            _vm._v(
                              _vm._s(_vm.metaUpcoming && _vm.metaUpcoming.total)
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "btn-status bg-grey" }, [
                          _vm._v(
                            _vm._s(
                              _vm.metaUpcoming && _vm.metaUpcoming.unassigned
                            ) + " not assigned"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary expand-all",
                            attrs: {
                              disabled:
                                _vm.jobsUpcoming && !_vm.jobsUpcoming.length
                            },
                            on: { click: _vm.toggleAllUpcomingJobs }
                          },
                          [
                            _c("i", {
                              class: [
                                _vm.jobsUpcoming && _vm.expandedAllUpcoming
                                  ? "fa fa-compress"
                                  : "fa fa-expand"
                              ]
                            })
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  !_vm.jobsUpcoming
                    ? [
                        _c(
                          "vue-content-loading",
                          { attrs: { width: 800, height: 180 } },
                          _vm._l(5, function(x) {
                            return _c("rect", {
                              key: x,
                              attrs: {
                                x: "10",
                                y: 15 * x * 1.8,
                                rx: "5",
                                ry: "5",
                                width: "720",
                                height: "6"
                              }
                            })
                          })
                        )
                      ]
                    : [
                        _vm.jobsUpcoming && _vm.jobsUpcoming.length
                          ? _c(
                              "div",
                              _vm._l(_vm.jobsUpcoming, function(job, index) {
                                return _c("JobsBlock", {
                                  key: index,
                                  attrs: {
                                    job: job,
                                    index: index,
                                    expanded: _vm.expandedUpcoming,
                                    dashboard: true
                                  },
                                  on: {
                                    "update:job": function($event) {
                                      job = $event
                                    },
                                    "update:index": function($event) {
                                      index = $event
                                    },
                                    "job-updated": function($event) {
                                      _vm.updateJob(
                                        _vm.jobsUpcoming,
                                        index,
                                        $event
                                      )
                                    },
                                    expanded: _vm.toggleJobUpcoming,
                                    update: _vm.callGetJobsUpcoming,
                                    showModalAcceptJob: function($event) {
                                      _vm.showModalAcceptJob = true
                                    }
                                  }
                                })
                              })
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.jobsUpcoming && !_vm.jobsUpcoming.length
                          ? _c("div", [
                              _vm._v("\n          No results found.\n        ")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("pagination", {
                          attrs: {
                            "change-page": _vm.changePageUpcoming,
                            meta: _vm.metaUpcoming
                          }
                        })
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "section",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.step === "completed",
                      expression: "step === 'completed'"
                    }
                  ]
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 l-m-b-20" }, [
                      _c("label", [_vm._v("COMPLETED")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "pull-right" }, [
                        _c(
                          "span",
                          { staticClass: "btn-status bg-grey border-right" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.metaCompleted && _vm.metaCompleted.total
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "btn-status bg-grey" }, [
                          _vm._v(
                            _vm._s(
                              _vm.metaCompleted && _vm.metaCompleted.unassigned
                            ) + " not assigned"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary expand-all",
                            attrs: {
                              disabled:
                                _vm.jobsCompleted && !_vm.jobsCompleted.length
                            },
                            on: { click: _vm.toggleAllCompletedJobs }
                          },
                          [
                            _c("i", {
                              class: [
                                _vm.jobsCompleted && _vm.expandedAllCompleted
                                  ? "fa fa-compress"
                                  : "fa fa-expand"
                              ]
                            })
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  !_vm.jobsCompleted
                    ? [
                        _c(
                          "vue-content-loading",
                          { attrs: { width: 800, height: 180 } },
                          _vm._l(5, function(x) {
                            return _c("rect", {
                              key: x,
                              attrs: {
                                x: "10",
                                y: 15 * x * 1.8,
                                rx: "5",
                                ry: "5",
                                width: "720",
                                height: "6"
                              }
                            })
                          })
                        )
                      ]
                    : [
                        _vm.jobsCompleted && _vm.jobsCompleted.length
                          ? _c(
                              "div",
                              _vm._l(_vm.jobsCompleted, function(job, index) {
                                return _c("JobsBlock", {
                                  key: index,
                                  attrs: {
                                    job: job,
                                    index: index,
                                    expanded: _vm.expandedCompleted,
                                    dashboard: true
                                  },
                                  on: {
                                    "update:job": function($event) {
                                      job = $event
                                    },
                                    "update:index": function($event) {
                                      index = $event
                                    },
                                    "job-updated": function($event) {
                                      _vm.updateJob(
                                        _vm.jobsCompleted,
                                        index,
                                        $event
                                      )
                                    },
                                    expanded: _vm.toggleCompletedJob,
                                    update: _vm.callGetJobsCompleted
                                  }
                                })
                              })
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.jobsCompleted && !_vm.jobsCompleted.length
                          ? _c("div", [
                              _vm._v("\n          No results found.\n        ")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("pagination", {
                          attrs: {
                            "change-page": _vm.changePageCompleted,
                            meta: _vm.metaCompleted
                          }
                        })
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "section",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.step === "incomplete",
                      expression: "step === 'incomplete'"
                    }
                  ]
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 l-m-b-20" }, [
                      _c("label", [_vm._v("INCOMPLETE")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "pull-right" }, [
                        _c(
                          "span",
                          { staticClass: "btn-status bg-grey border-right" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.metaIncomplete && _vm.metaIncomplete.total
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "btn-status bg-grey" }, [
                          _vm._v(
                            _vm._s(
                              _vm.metaIncomplete &&
                                _vm.metaIncomplete.unassigned
                            ) + " not assigned"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary expand-all",
                            attrs: {
                              disabled:
                                _vm.jobsIncomplete && !_vm.jobsIncomplete.length
                            },
                            on: { click: _vm.toggleAllIncompleteJobs }
                          },
                          [
                            _c("i", {
                              class: [
                                _vm.jobsIncomplete && _vm.expandedAllIncomplete
                                  ? "fa fa-compress"
                                  : "fa fa-expand"
                              ]
                            })
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  !_vm.jobsIncomplete
                    ? [
                        _c(
                          "vue-content-loading",
                          { attrs: { width: 800, height: 180 } },
                          _vm._l(5, function(x) {
                            return _c("rect", {
                              key: x,
                              attrs: {
                                x: "10",
                                y: 15 * x * 1.8,
                                rx: "5",
                                ry: "5",
                                width: "720",
                                height: "6"
                              }
                            })
                          })
                        )
                      ]
                    : [
                        _vm.jobsIncomplete && _vm.jobsIncomplete.length
                          ? _c(
                              "div",
                              _vm._l(_vm.jobsIncomplete, function(job, index) {
                                return _c("JobsBlock", {
                                  key: index,
                                  attrs: {
                                    job: job,
                                    index: index,
                                    expanded: _vm.expandedIncomplete,
                                    dashboard: true
                                  },
                                  on: {
                                    "update:job": function($event) {
                                      job = $event
                                    },
                                    "update:index": function($event) {
                                      index = $event
                                    },
                                    "job-updated": function($event) {
                                      _vm.updateJob(
                                        _vm.jobsIncomplete,
                                        index,
                                        $event
                                      )
                                    },
                                    expanded: _vm.toggleIncompleteJob,
                                    update: _vm.callGetJobsIncomplete,
                                    showModalAcceptJob: function($event) {
                                      _vm.showModalAcceptJob = true
                                    }
                                  }
                                })
                              })
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.jobsIncomplete && !_vm.jobsIncomplete.length
                          ? _c("div", [
                              _vm._v("\n          No results found.\n        ")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("pagination", {
                          attrs: {
                            "change-page": _vm.changePageIncomplete,
                            meta: _vm.metaIncomplete
                          }
                        })
                      ]
                ],
                2
              )
            ]
          : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showFilters
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showFilters = false
                  }
                }
              },
              [
                _vm.showFilters
                  ? _c(
                      "div",
                      { staticClass: "filters-side-modal flex flex-column" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "pointer",
                            on: {
                              click: function($event) {
                                _vm.showFilters = !_vm.showFilters
                              }
                            }
                          },
                          [
                            _c("h1", { staticClass: "modal-h1 l-m-b-20" }, [
                              _c("span", { staticClass: "btn btn-back" }),
                              _vm._v("Add Filter")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", [
                            _vm._v(
                              "\n            Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.\n          "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "l-bg-white" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c("div", { staticClass: "row filters" }, [
                                _vm.companies && _vm.companies.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Company")]),
                                          _vm._v(" "),
                                          _c("key-multiselect", {
                                            attrs: {
                                              options: _vm.companies,
                                              multiple: true,
                                              "clear-on-select": false,
                                              "close-on-select": false,
                                              "hide-selected": true,
                                              id: "company-select",
                                              placeholder: "Select Company",
                                              "preserve-search": false,
                                              label: "name",
                                              "track-by": "id"
                                            },
                                            on: { input: _vm.search },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "multiselect__tag"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option.name
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "multiselect__tag-icon",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              props.remove(
                                                                props.option
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.filters.company,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "company",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.company"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.carriers && _vm.carriers.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Carriers")]),
                                          _vm._v(" "),
                                          _c("key-multiselect", {
                                            attrs: {
                                              options: _vm.carriers,
                                              multiple: true,
                                              "clear-on-select": false,
                                              "close-on-select": false,
                                              "hide-selected": true,
                                              id: "carrier-select",
                                              placeholder: "Select Carriers",
                                              "preserve-search": false,
                                              label: "name",
                                              "track-by": "id"
                                            },
                                            on: { input: _vm.search },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "multiselect__tag"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option.name
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "multiselect__tag-icon",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              props.remove(
                                                                props.option
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.filters.carrier,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "carrier",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.carrier"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.clusterUsersFilter &&
                                _vm.clusterUsersFilter.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [
                                            _vm._v("User companies")
                                          ]),
                                          _vm._v(" "),
                                          _c("simple-select", {
                                            attrs: {
                                              options: _vm.clusterUsersFilter,
                                              "input-id":
                                                "user-companies-select",
                                              placeholder: "Select User",
                                              "track-by": "id",
                                              label: "full_name"
                                            },
                                            on: { input: _vm.search },
                                            model: {
                                              value: _vm.filters.userCompanies,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "userCompanies",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filters.userCompanies"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Move Size")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.moveSizes,
                                          "input-id": "move-size-select",
                                          placeholder: "Select Move Size"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.moveSize,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "moveSize",
                                              $$v
                                            )
                                          },
                                          expression: "filters.moveSize"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Move date")]),
                                      _vm._v(" "),
                                      _c("flat-pickr", {
                                        staticClass: "simple-select-input",
                                        attrs: {
                                          config: _vm.config,
                                          placeholder: "Select Move Date",
                                          name: "date"
                                        },
                                        on: { "on-close": _vm.onDateChange },
                                        model: {
                                          value: _vm.filters.moveDate,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "moveDate",
                                              $$v
                                            )
                                          },
                                          expression: "filters.moveDate"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.filters.moveDate
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "position-absolute clear-date",
                                              on: {
                                                click: _vm.clearDateAndSearch
                                              }
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "mod-icon-clear"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "sr-only",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                },
                                                [_vm._v("Clear")]
                                              )
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            {
                                              staticClass:
                                                "position-absolute clear-date clear-date-transparent"
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "mod-icon-rates-dark"
                                              })
                                            ]
                                          )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Status")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.jobStatuses,
                                          "input-id": "status-select",
                                          placeholder: "Select Status"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.status,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filters, "status", $$v)
                                          },
                                          expression: "filters.status"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Cash collected")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.booleanOptions,
                                          "input-id": "has-subscription-select",
                                          placeholder: "Select"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.cash_collected,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "cash_collected",
                                              $$v
                                            )
                                          },
                                          expression: "filters.cash_collected"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-auto" }, [
                          _c("div", { staticClass: "col" }, [
                            !_vm.clearFiltersButtonShouldBeDisabled
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-not-active text-dark w-100",
                                    attrs: { type: "button" },
                                    on: { click: _vm.clearFilters }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Clear filters\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d79beb4e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d79beb4e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Dashboard.vue
// module id = null
// module chunks = 